import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import { clear } from "@testing-library/user-event/dist/clear";

const AddWorkShop = () => {
  const history = useHistory();
  const [disabled, setdisabled] = useState(false);
  //const [isChecked, setChecked] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const eventName = localStorage.getItem('eventname');
  const eventid = localStorage.getItem('eventid')
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [workShopCategory, setWorkShopCategory] = useState('');
  const [workshopCategoryData, setWorkShopCategoryData] = useState([]);
  const [addWorkShop, setAddWorkShop] = useState({
    event_name: eventName,
    w_workshop_code: "",
    w_workshop_name: "",
    w_workshop_url: "",
    w_workshop_amount: "",
    w_workshop_seats: "",
    w_workshop_discount_amount:"",

    error_list: [],
  });
  const handleCheckboxChange = () => {
    setChecked(!isChecked);
  };
  useEffect(() => {
    axios.get(`api/workshop-category-index?id=${eventid}`).then(res => {
      if (res.status == 200) {
        const wcategoryData = res.data.workshopCategories;
        setWorkShopCategoryData(wcategoryData);
      }
      else {
        swal('Error', "Check API Something Wrong", 'error');

      }


    });

  }, []);


  // const handleCheckboxChange = () => {
  //     setChecked(!isChecked);
  // };

  const handleInput = (e) => {
    e.persist();
    setAddWorkShop({ ...addWorkShop, [e.target.name]: e.target.value });
  }



  const handleStartTime = (event) => {
    setStartTime(event.target.value);
  };

  const handleEndTime = (event) => {
    setEndTime(event.target.value);
  };



  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleWorkShopCategory = (e) => {
    setWorkShopCategory(e.target.value);
  }

  const submitWorkShop = (e) => {

    e.preventDefault();

    const data = {
      eventid,
      event_name: addWorkShop.event_name,
      workshop_code: addWorkShop.w_workshop_code,
      workshop_name: addWorkShop.w_workshop_name,
      workshop_url: addWorkShop.w_workshop_url,
      workshop_amount: addWorkShop.w_workshop_amount,
      workshop_discount_amount: addWorkShop.w_workshop_discount_amount,
      workshop_no_of_seats: addWorkShop.w_workshop_seats,
      workshop_start_time: startTime,
      workshop_end_time: endTime,
      workshop_date: selectedDate,
      workShopCategory,
       isChecked,

    }
    //   console.clear();
    // console.log(data)
    //   data.title == "" ? setdisabled(false) :
    //       data.descriptions == "" ? setdisabled(false) :
    //           setdisabled(true)

    axios.get('/sanctum/csrf-cookie').then(response => {

      axios.post(`/api/workshop-store`, data).then(res => {

        if (res.data.status === 200) {


          swal('Success', res.data.message, 'success');

          history.push('/admin/workshop/manage');
        }
        else {

          setAddWorkShop({ ...addWorkShop, error_list: res.data.validate_error })

        }

      });


    });


  }
  const [abstractHomeSetup, setAbstractHomeSetup] = useState({
    color_code: "",
    color_code_two: "",
    color_code_three: "",
    call_emergency: "",
    send_email: "",
    event_place: "",
    facebook_link: "",
    Instagram_link: "",
    linkedin_link: "",
    twitter_link: "",
    abstractFooterImage: "",
    abstractBannerImage: "",
    abstractSponserLogos: "",
    error_list: [],
});
React.useEffect(() => {
    axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
        if (res.status === 200) {
            const getHomePageData = res.data.HomePageSetup;
            setAbstractHomeSetup(getHomePageData);
        }
    })

}, [eventid]);



let backGroundButtonByEvent = "";
if (eventid) {
    backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
}
else {
    backGroundButtonByEvent = '#145348'; // Default background color
}
//backgroundColor: backGroundButtonByEvent,

  return (

    <div style={{ margin: '1%', width: '60vw', marginLeft: '10%' }}>
      <Box sx={{ color: '#000000', }} style={{ marginTop: '5%' }}>
        <h4 sx={{ m: 2, color: '#000000' }} >
          <Button sx={{
            float: 'right',
            marginTop: '2%',
            backgroundColor: backGroundButtonByEvent,
            ":hover": {
              color: "white"
            }
          }}
            color='success'
            size='small'
            variant='contained'
            onClick={() => history.goBack()}>
            Back
          </Button>
        </h4>
        <Card sx={{ width: '60vw', float: 'center' }} >
          <CardContent >
            <Typography component="h1" variant="h5">
              Add WorkShop
            </Typography>
            <Box component="form" onSubmit={submitWorkShop} noValidate sx={{ mt: 3 }}>
              <Grid container spacing={4}>
                <Grid item xs={6} >
                  <TextField
                    disabled
                    autoComplete="given-name"
                    required
                    fullWidth
                    label="Evnet Name"
                    autoFocus
                    name='event_name' onChange={handleInput}
                    defaultValue={eventName || ""}
                    helperText={addWorkShop.error_list.title} />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Workshop Category</InputLabel>
                    <Select

                      value={workShopCategory || ""}
                      onChange={handleWorkShopCategory}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Workshop Category" >
                      {
                        workshopCategoryData && workshopCategoryData.map((val, index) => {
                          return (
                            <MenuItem value={val.id} key={val.id}>{val.workshop_category_title} </MenuItem>
                          )
                        })
                      }



                    </Select>

                    <FormHelperText></FormHelperText>
                  </FormControl>
                </Grid>

                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    label="WorkShop Code"
                    autoFocus
                    name='w_workshop_code' onChange={handleInput}
                    helperText={addWorkShop.error_list.w_workshop_code} />
                </Grid>
                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    label="WorkShop Name"
                    autoFocus
                    name='w_workshop_name' onChange={handleInput}
                    helperText={addWorkShop.error_list.w_workshop_name} />
                </Grid>
                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    label="workshop Day"
                    autoFocus
                    name='w_workshop_url' onChange={handleInput}
                    helperText={addWorkShop.error_list.w_workshop_url} />
                </Grid>
                {/* <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    label="workshop Date"
                    autoFocus
                    name='w_workshop_url' onChange={handleInput}
                    helperText={addWorkShop.error_list.w_workshop_url} />
                </Grid> */}


                <Grid item xs={6} >
                  <TextField
                    id="date"
                    fullWidth
                    label="WorkShop Date"
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6} >
                  <TextField
                    id="time"
                    label="Start Time"
                    type="time"
                    fullWidth
                    value={startTime}
                    onChange={handleStartTime}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 minutes interval
                    }} />
                </Grid>
                <Grid item xs={6} >
                  <TextField
                    id="time"
                    label="End Time"
                    type="time"
                    fullWidth
                    value={endTime}
                    onChange={handleEndTime}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300, // 5 minutes interval
                    }} />
                </Grid>

                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    type="number"
                    label="Non MemberShip Price"
                    autoFocus
                    name='w_workshop_amount' onChange={handleInput}
                    helperText={addWorkShop.error_list.w_workshop_amount} />
                </Grid>
                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    type="number"
                    label="MemberShip Price"
                    autoFocus
                    name='w_workshop_discount_amount' onChange={handleInput}
                    helperText={addWorkShop.error_list.w_workshop_discount_amount} />
                </Grid>
                <Grid item xs={6} >
                  <TextField
                    autoComplete="given-name"
                    required
                    fullWidth
                    type="number"
                    label="No of seats"
                    autoFocus
                    name='w_workshop_seats' onChange={handleInput}
                    helperText={addWorkShop.error_list.w_workshop_seats} />
                </Grid>
                <Grid item xs={6} >
                  <FormControlLabel control={<Checkbox color="success" />}
                    label="Coupon"
                    color="success"
                    onChange={handleCheckboxChange} checked={isChecked} />
                  <br></br>
                  <Typography
                    component="span" style={{ color: "#311b92", fontSize: "90%" }}>
                    Coupon is {isChecked ? ' Applied' : ' Not Applied'}.
                  </Typography>

                </Grid>


                {/* <Grid item xs={12} >
                                  <FormControlLabel required control={<Checkbox color="success" />}
                                      label=" Coupon"
                                      color="success"
                                      onChange={handleCheckboxChange} value="41" checked={isChecked} />
                                  <FormHelperText>Coupon is {isChecked ? ' Applied' : ' Not Applied'}.</FormHelperText>
                              </Grid> */}





              </Grid>

              <Grid container justifyContent="flex-end">
                <Button
                  disabled={disabled}
                  type="submit"
                  // fullWidth
                  variant="contained"
                  sx={{ mt: 5, backgroundColor: backGroundButtonByEvent, }} >
                  Add WorkShop
                </Button>
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </div>

  );
}

export default AddWorkShop;
